import { render, staticRenderFns } from "./ManufactureDashboard.vue?vue&type=template&id=4e5ad570&scoped=true&"
import script from "./ManufactureDashboard.vue?vue&type=script&lang=js&"
export * from "./ManufactureDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManufactureDashboard.vue?vue&type=style&index=0&id=4e5ad570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ad570",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBreadcrumbs,VBtn,VCol,VContainer,VIcon,VImg,VLayout,VRow,VSimpleTable})
